import { render, staticRenderFns } from "./PlayerSettings.vue?vue&type=template&id=c9fe03ce&"
import script from "./PlayerSettings.vue?vue&type=script&lang=js&"
export * from "./PlayerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports